<template>
  <div class="info-box-wrapper">
    <InfoBox :text="$t('message.facebook.info1')" />
    <InfoBox
      :text="$t('message.facebook.info2')"
      more-info-link="https://center.ai/"
    />
  </div>
</template>

<script>
import InfoBox from "@/components/ui/InfoBox.vue";

export default {
  name: "FacebookAccountsAccountInfoBoxes",
  components: {
    InfoBox
  }
};
</script>
<style lang="scss" scoped>
.info-box-wrapper {
  display: flex;
  flex-direction: column;
  gap: $spacing;
}
</style>
